// Construye la URL del iframe de firma a partir del link que entrega el backend.
// - Si REACT_APP_SIGNING_ORIGIN está definido (p. ej. http://localhost:8001 en
//   desarrollo), reemplaza el origen del link por ese valor.
// - En cualquier otro caso fuerza https para evitar contenido mixto.
export const buildSigningFrameUrl = (
  signingLink: string | null | undefined,
  language?: string | null
): string => {
  const override = process.env.REACT_APP_SIGNING_ORIGIN;
  let link = (signingLink ?? "").replace("sign", "sign-box");

  try {
    const url = new URL(link);
    if (override) {
      link = override.replace(/\/$/, "") + url.pathname + url.search;
    } else if (url.protocol === "http:") {
      url.protocol = "https:";
      link = url.toString();
    }
  } catch {
    // link relativo o inválido: se usa tal cual
  }

  return link.concat(language === "en" ? "?lang=en" : "?lang=es");
};
